<template>
  <dialog-info
    ref="dialog"
    :title="title"
    @close="handlerClose"
  >
    <list-form
      ref="list-form"
      :formModel="formModel"
      :config="config"
    >
      <template v-slot="{ data, item, updateDataItem, autoSave }">
        <activity-item
          :data="data"
          :item="item"
          :formModel="formModel"
          :autoSave="autoSave"
          @change="updateDataItem"
          @onSendEmail="handlerSendEmail"
          @updatedData="refresh"
          @onStockCard="handlerStockCard"
        >
        </activity-item>
      </template>
    </list-form>
    <dialog-stock-card
      ref="dialog-stock-card"
    />
  </dialog-info>
</template>

<script>
import { waitValue } from '@/utils/promises'
import { MainModel } from '@/models/CustomerPOFollowUp'
import listFormConfig from './ListFormConfig'

export default {
  name: 'DialogConnect',
  components: {
    'dialog-info': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogInfo'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'activity-item': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityItemCustomerPoFollowUp/Index'),
    'dialog-stock-card': () => import(/* webpackChunkName: 'DialogStockCard' */ '@/components/Shared/Activity/DialogStockCard')
  },
  props: {
    filterFieldName: { type: String, default: 'rfqid' },
    filterValueTemplate: {
      type: Function,
      default: (filterValue) => {
        return `rfqid == "${filterValue}"`
      }
    }
  },
  data () {
    return {
      filterValue: null,
      data: {},
      config: listFormConfig
    }
  },
  computed: {
    title () {
      return this.filterValue
    }
  },
  methods: {
    formModel () {
      return new MainModel()
    },
    refresh () {
      this.getListForm()
        .then((listForm) => {
          listForm.refresh()
        })
    },
    getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    loadData () {
      if (!this.filterValue) return
      this.getListForm()
        .then((listForm) => {
          listForm.setFilters(this.filterValueTemplate(this.filterValue))
          listForm.loadData()
        })
    },
    show (data) {
      this.filterValue = data[this.filterFieldName]
      this.$refs['dialog'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog'].hide()
    },
    handlerClose () {
      this.getListForm()
        .then((listForm) => {
          listForm.clear()
        })
    },
    handlerStockCard () {
      this.$refs['dialog-stock-card'].show(...arguments)
    },
    handlerSendEmail () {
      this.$emit('onSendEmail', ...arguments)
    }
  }
}
</script>
